// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v_L4JU9IYndX0xn36pqI{min-height:48px;padding:12px 16px 12px 20px}.vRWCZj8f3lk6NChNBOLp{align-self:center;align-items:center;padding:0 4px}.vRWCZj8f3lk6NChNBOLp>div{height:40px}.vRWCZj8f3lk6NChNBOLp>div>div{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `v_L4JU9IYndX0xn36pqI`,
	"header__alert": `vRWCZj8f3lk6NChNBOLp`,
	"headerAlert": `vRWCZj8f3lk6NChNBOLp`
};
export default ___CSS_LOADER_EXPORT___;
